/**
 * WordPress dependencies
 */
import { store, getContext } from '@wordpress/interactivity';

const { state } = store('gt/promotions', {
  state: {
    promotions: [],
    promotionsLinks: [],
  },
  actions: {
    async fetchPromotions() {
      try {
        const context = getContext(); // contient { lang, camp, hasPromo, ... } via render.php

        // Construire l'URL proprement
        const params = new URLSearchParams();
        if (context?.lang) params.set('lang', context.lang);
        if (context?.camp) params.set('camp', context.camp); // ⬅️ clé ! filtre côté API
        params.set('cacheBust', String(Date.now())); // éviter caches agressifs

        const response = await fetch(`/wp-json/geek-tonic/v1/promotions?${params.toString()}`);
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();

        if (data?.success) {
          const list = Array.isArray(data.promotions) ? data.promotions : [];
          // Séparer promos avec lien / sans lien
          state.promotionsLinks = list.filter((p) => (p.link || '').trim() !== '');
          state.promotions = list.filter((p) => !p.link || p.link.trim() === '');

          context.hasPromo =
            (state.promotionsLinks?.length || 0) + (state.promotions?.length || 0) > 0;

          // Si Swiper existe déjà, le rafraîchir après l’injection
          const wrapper = document.querySelector('.wp-block-gt-gt-fse-promotions .swiper');
          const swiper = wrapper && wrapper.swiper;
          if (swiper) {
            // petit délai pour laisser le DOM se mettre à jour
            setTimeout(() => swiper.update(), 150);
          }
        } else {
          console.error('Failed to fetch promotions (payload error).', data);
          context.hasPromo = false;
          state.promotions = [];
          state.promotionsLinks = [];
        }
      } catch (err) {
        console.error('fetchPromotions error', err);
        const context = getContext();
        context.hasPromo = false;
        state.promotions = [];
        state.promotionsLinks = [];
      }
    },
  },
  callbacks: {
    promotionsChanged(newPromotions) {
      // debug éventuel
      // console.log('Promotions updated:', newPromotions);
    },
  },
});
